import { Component, ChangeDetectorRef } from '@angular/core';
import { NavController, Events, App } from 'ionic-angular';
import { EventCodes } from '../../../../core/codes';
import { ProfileCommon } from './profile.common';
import { PageBase } from '../../../../core/page-base';
import { UserData } from '../../../../providers/user-data'; 
import { AppSettings } from '../../../../config/app-settings';
import { PageRef } from '../../../../core/core.module';
//import { RecipeData } from '../../../recipes/providers/recipe-data';


@Component({
	selector: 'page-profile',
	templateUrl: 'profile.html'
})

export class ProfilePage extends PageBase{
	public submitted = false;
	public formMsg: any;
	
	constructor(
		public events: Events,
		public app: App,
		public cd: ChangeDetectorRef,		
		public common: ProfileCommon,
		public nav: NavController,
    	public userData: UserData,
    	public settings: AppSettings,
    	public pageRef: PageRef,
    	//public recipeData: RecipeData,
    ) {	
    	super(settings, events, nav, userData);
		console.log("Loading Profile Mobile");
	}

	ionViewDidEnter() {
		this.app.setTitle('Profile');
	}

	ngAfterViewInit() {
		let self = this;
		self.events.subscribe(EventCodes.USER_LOGIN_ERROR, (err)=>{
			self.formMsg = err;
			this.cd.detectChanges();
		});	
	}

	
	
}


// WEBPACK FOOTER //
// ./src/modules/account/pages/profile/profile.ts